import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { StepByStepService } from 'src/app/shared/step-by-step.service';

@Component({
  selector: 'app-send-email',
  templateUrl: './send-email.component.html',
  styleUrls: ['./send-email.component.css']
})
export class SendEmailComponent implements OnInit {

  @Input() note: string = '';

  public email: string = '';
  public check: boolean = false;
  public patternEmail = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z0-9-.]{2,6}$'
  public thxMsg: boolean = false;

  @Output() closeModal = new EventEmitter<boolean>();

  constructor(private stepByStepService: StepByStepService) { }

  ngOnInit(): void {
  }

  public closeSendingEmail(close: boolean): void {
    this.closeModal.emit(close);
  }

  public send(): void {
    this.thxMsg = true;
    setTimeout(() => {
      this.thxMsg = false;
      this.closeSendingEmail(true);
    }, 3000)

    let comments = this.stepByStepService.comments
    /** place for custom logic for intercepting of inscribed message (comments) and email addres (this.email) **/
    /** comments is object {customerRequest: string, other: string}**/
  }

  public printInput(sth: any) {
  }

}
